<ion-header class="ion-no-border" [translucent]="true">
  <ion-toolbar
    [color]="mobile() ? '' : 'secondary-detail'"
    [class.detail-page]="!mobile()"
  >
    <ion-buttons slot="start">
      <ion-back-button [text]="originPage"></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="generateReport()">
        <ion-icon slot="icon-only" name="print"></ion-icon>
      </ion-button>
      <ion-button (click)="openStudentModal()">
        <ion-icon name="pencil-outline"></ion-icon>
      </ion-button>
      <ion-button (click)="presentDeleteActionSheet()">
        <ion-icon name="ellipsis-vertical"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="max-width-content" [class.ion-padding-top]="mobile()">
  @defer (when !androidFakeLoading()) { @if (studentSignal(); as student) {
  <div [class.padding-content]="!mobile()">
    <!-- show the avatar -->
    <div class="flex flex-row justify-start mb-6">
      <div
        class="flex flex-col items-center"
        [class.ion-padding-horizontal]="mobile()"
      >
        <div class="flex flex-row justify-start">
          @if ((!student.profile_picture_url || !student.has_profile_picture)) {
          <div
            [style.background-color]="getColor(student)"
            class="mr-3 relative inline-flex items-center justify-center w-16 h-16 overflow-hidden rounded-full"
          >
            <span class="font-medium text-3xl text-white dark:text-gray-300">{{
              student.forename.substring(0, 1)
            }}</span>
          </div>
          } @if (student.profile_picture_url && student.has_profile_picture) {
          <img
            class="avatar mr-3 relative inline-flex items-center justify-center w-16 h-16 overflow-hidden rounded-full tappable-image"
            [ngSrc]="student.profile_picture_url"
            width="40"
            height="40"
            [alt]="student.forename"
            rel="preconnect"
            (click)="openProfileImage(student.profile_picture_url)"
          />
          }
          <div class="flex flex-col justify-center">
            <div class="flex flex-col gap-1">
              <ion-text class="text-2xl"
                >{{ student.forename }} {{ student.surname }}</ion-text
              >
              <ion-text class="text-md text-gray-500"
                >Guthaben:
                {{
                  !student.subscription_lessons
                    ? "0 Lektionen"
                    : student.subscription_lessons === 1
                    ? student.subscription_lessons + " Lektion"
                    : student.subscription_lessons + " Lektionen"
                }}</ion-text
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div [class.ion-padding-horizontal]="mobile()">
      <ion-grid class="button-grid">
        <ion-row>
          <ion-col>
            <ion-button
              fill="outline"
              class="w-full top-button"
              (click)="openNewLessonDialog()"
            >
              <div class="flex flex-col items-center">
                <ion-icon
                  class="text-2xl"
                  slot="icon-only"
                  name="car"
                ></ion-icon>
                <span class="text-xs font-normal">Termin</span>
              </div>
            </ion-button>
          </ion-col>
          <ion-col>
            <ion-button
              fill="outline"
              class="w-full top-button"
              (click)="openNewInvoiceDialog()"
            >
              <div class="flex flex-col items-center">
                <ion-icon
                  class="text-2xl"
                  slot="icon-only"
                  name="document-text"
                ></ion-icon>
                <span class="text-xs font-normal">Rechnung</span>
              </div>
            </ion-button>
          </ion-col>
          <ion-col>
            <ion-button
              fill="outline"
              class="w-full top-button"
              (click)="openNewPaymentDialog()"
            >
              <div class="flex flex-col items-center">
                <ion-icon
                  class="text-2xl"
                  slot="icon-only"
                  name="wallet"
                ></ion-icon>
                <span class="text-xs font-normal">Zahlung</span>
              </div>
            </ion-button>
          </ion-col>
          <ion-col>
            <ion-button
              fill="outline"
              class="w-full top-button"
              (click)="openNewSubscriptionAlert()"
            >
              <div class="flex flex-col items-center">
                <ion-icon
                  class="text-2xl"
                  slot="icon-only"
                  name="gift"
                ></ion-icon>
                <span class="text-xs font-normal">Abo</span>
              </div>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <ion-segment
      class="mt-6"
      [(ngModel)]="section"
      [class.custom-segment]="mobile()"
    >
      <ion-segment-button value="details">
        <ion-icon name="information-circle-outline"></ion-icon>
      </ion-segment-button>
      <ion-segment-button value="lessons">
        <ion-icon name="car-outline"></ion-icon>
      </ion-segment-button>
      <ion-segment-button value="invoices">
        <ion-icon name="wallet-outline"></ion-icon>
      </ion-segment-button>
      <ion-segment-button value="education">
        <ion-icon name="school-outline"></ion-icon>
      </ion-segment-button>
    </ion-segment>

    <div [class.ion-padding-horizontal]="mobile()">
      @switch (section) { @case ('details') { @defer (when section ===
      'details') {
      <div>
        <ion-list color="tertiary" lines="none" class="mb-6 mt-4 rounded-lg">
          @if (student.mobile_no) {
          <ion-item color="tertiary">
            <ion-note slot="start">
              <ion-icon
                color="primary"
                name="call-outline"
                class="text-lg"
              ></ion-icon>
            </ion-note>
            <a
              [href]="'tel:' + student.mobile_no"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ion-label>{{ student.mobile_no }}</ion-label>
            </a>
          </ion-item>
          } @if (student.mail_student) {
          <ion-item color="tertiary">
            <ion-note slot="start">
              <ion-icon
                color="primary"
                name="mail-outline"
                class="text-lg"
              ></ion-icon>
            </ion-note>
            <a
              [href]="'mailto:' + student.mail_student"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ion-label>{{ student.mail_student }}</ion-label>
            </a>
          </ion-item>
          } @if (student.street || student.postal_code || student.city) {
          <ion-item color="tertiary">
            <ion-note slot="start">
              <ion-icon
                color="primary"
                name="location-outline"
                class="text-lg"
              ></ion-icon>
            </ion-note>
            <!-- <ion-label
              >{{ student.street }} <br />
              {{ student.postal_code }} {{ student.city }}</ion-label
            > -->
            <ion-label color="dark"
              ><a
                [href]="
                  getGoogleMapsLink(
                    student.street,
                    student.postal_code,
                    student.city
                  )
                "
                class="text-md"
                >{{ student.street }} <br />
                {{ student.postal_code }} {{ student.city }}</a
              ></ion-label
            >
          </ion-item>
          } @if (student.birthday) {
          <ion-item color="tertiary">
            <ion-note slot="start">
              <ion-icon
                color="primary"
                name="calendar-outline"
                class="text-lg"
              ></ion-icon>
            </ion-note>
            <ion-label>
              <span>{{ student.birthday | date : "dd.MM.yyyy" }}</span>
              <span class="text-xs text-gray-500 ml-2"
                >({{ getAge(student.birthday) }} Jahre)</span
              >
            </ion-label>
          </ion-item>
          } @if (student.category) {
          <ion-item color="tertiary">
            <ion-note slot="start">
              <ion-icon
                color="primary"
                name="car-outline"
                class="text-lg"
              ></ion-icon>
            </ion-note>
            <ion-label>{{ student.category }}</ion-label>
          </ion-item>
          }
        </ion-list>
        <ion-list color="tertiary" lines="none" class="mb-6 mt-4 rounded-lg">
          @if (student.exam_location) {
          <ion-item color="tertiary">
            <ion-note slot="start">
              <ion-icon
                color="primary"
                name="school-outline"
                class="text-lg"
              ></ion-icon>
            </ion-note>
            <ion-label>Prüfungsort: {{ student.exam_location }}</ion-label>
          </ion-item>
          } @if (student.category === "B" || student.category === "BE") {
          <ion-item color="tertiary">
            <ion-note slot="start">
              <ion-icon
                [color]="student.vku_completed ? 'success' : 'medium'"
                [name]="
                  student.vku_completed ? 'checkmark-circle' : 'close-circle'
                "
                class="text-lg"
              ></ion-icon>
            </ion-note>
            <ion-label>
              <span>VKU</span>
              @if (student.vku_completed) {
              <span class="text-xs text-gray-500 ml-2">
                @if (student.vku_date) { (absolviert am
                {{ getFormattedDate(student.vku_date) }}) } @else { (absolviert)
                }
              </span>
              } @else {
              <span class="text-xs text-gray-500 ml-2">(nicht absolviert)</span>
              }
            </ion-label>
          </ion-item>
          } @if (student.notes) {
          <ion-item color="tertiary">
            <ion-note slot="start">
              <ion-icon
                color="primary"
                name="document-text-outline"
                class="text-lg"
              ></ion-icon>
            </ion-note>
            <ion-label>{{ student.notes }}</ion-label>
          </ion-item>
          }
        </ion-list>
        @if (student.lfa_number || student.lfa_pin || student.lfa_pid ||
        student.lfa_start || student.lfa_end) {
        <ion-list color="tertiary" lines="none" class="mb-6 mt-4 rounded-lg">
          @if (student.lfa_number) {
          <ion-item color="tertiary">
            <ion-note slot="start">
              <ion-icon
                color="primary"
                name="id-card-outline"
                class="text-lg"
              ></ion-icon>
            </ion-note>
            <ion-label
              ><p class="text-sm">LFA-Nummer:</p>
              {{ student.lfa_number }}</ion-label
            >
          </ion-item>
          } @if (student.lfa_pin || student.lfa_pid) {
          <ion-item color="tertiary" lines="none">
            <ion-grid class="p-0 m-0 w-full">
              <ion-row>
                @if (student.lfa_pin) {
                <ion-col size="6" class="p-0">
                  <div class="flex items-center">
                    <ion-note class="mr-4">
                      <ion-icon color="primary" class="text-lg"></ion-icon>
                    </ion-note>
                    <ion-label
                      ><p class="text-sm">Pin:</p>
                      {{ student.lfa_pin }}</ion-label
                    >
                  </div>
                </ion-col>
                } @if (student.lfa_pid) {
                <ion-col size="6" class="p-0">
                  <div class="flex items-center">
                    <ion-note class="mr-4">
                      <ion-icon color="primary" class="text-lg"></ion-icon>
                    </ion-note>
                    <ion-label
                      ><p class="text-sm">PID:</p>
                      {{ student.lfa_pid }}</ion-label
                    >
                  </div>
                </ion-col>
                }
              </ion-row>
            </ion-grid>
          </ion-item>
          } @if (student.lfa_start && student.lfa_end) {
          <ion-item color="tertiary">
            <ion-note slot="start">
              <ion-icon
                color="primary"
                name="calendar-outline"
                class="text-lg"
              ></ion-icon>
            </ion-note>
            <ion-label>
              Gültigkeit: {{ getFormattedDate(student.lfa_start) }} -
              {{ getFormattedDate(student.lfa_end) }}
            </ion-label>
          </ion-item>
          }
        </ion-list>
        }
        <ion-list color="tertiary" lines="none" class="mb-6 mt-4 rounded-lg">
          <ion-accordion-group mode="ios">
            <ion-accordion value="exam-requirements">
              <ion-item color="light" slot="header">
                <ion-icon
                  [color]="canRegisterForExam(student) ? 'success' : 'danger'"
                  [name]="
                    canRegisterForExam(student)
                      ? 'checkmark-circle'
                      : 'alert-circle'
                  "
                  class="text-lg mr-4"
                >
                </ion-icon>
                <ion-label>
                  <span class="font-medium">
                    {{
                      canRegisterForExam(student)
                        ? "Prüfungsanmeldung möglich"
                        : "Prüfungsanmeldung nicht möglich"
                    }}
                  </span>
                </ion-label>
              </ion-item>

              <div slot="content" class="p-0">
                <!-- VKU Status -->
                <ion-item color="tertiary">
                  <ion-icon
                    [color]="student.vku_completed ? 'success' : 'medium'"
                    [name]="
                      student.vku_completed
                        ? 'checkmark-circle'
                        : 'close-circle'
                    "
                    class="text-lg mr-4"
                  >
                  </ion-icon>
                  <ion-label>
                    <span>VKU</span>
                    @if (student.vku_completed) {
                    <span class="text-xs text-gray-500 ml-2">
                      @if (student.vku_date) { (absolviert am
                      {{ getFormattedDate(student.vku_date) }}) } @else {
                      (absolviert) }
                    </span>
                    }
                  </ion-label>
                </ion-item>

                <!-- LFA Validity -->
                <ion-item color="tertiary">
                  <ion-icon
                    [color]="isLfaValid(student) ? 'success' : 'danger'"
                    [name]="
                      isLfaValid(student) ? 'checkmark-circle' : 'close-circle'
                    "
                    class="text-lg mr-4"
                  >
                  </ion-icon>
                  <ion-label>
                    <span> Lernfahrausweis gültig </span>
                    @if (!isLfaValid(student) && student.lfa_end) {
                    <span class="text-xs text-red-500 ml-2"
                      >(abgelaufen am
                      {{ getFormattedDate(student.lfa_end) }})</span
                    >
                    }
                  </ion-label>
                </ion-item>

                <!-- Age Requirement -->
                <ion-item color="tertiary" lines="full">
                  <ion-icon
                    [color]="
                      meetsAgeRequirement(student) ? 'success' : 'medium'
                    "
                    [name]="
                      meetsAgeRequirement(student) ? 'checkmark-circle' : 'time'
                    "
                    class="text-lg mr-4"
                  >
                  </ion-icon>
                  <ion-label>
                    <span>Altersanforderung</span>
                    @if (!meetsAgeRequirement(student) && student.lfa_start &&
                    student.birthday) {
                    <span class="text-xs text-gray-500 ml-2">
                      (erfüllt ab {{ getAgeRequirementDate(student) }})
                    </span>
                    }
                  </ion-label>
                </ion-item>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-list>
      </div>
      @if (student.attachments && student.attachments.length > 0) {
      <ion-list color="dark" lines="none" class="mb-6 mt-4 rounded-lg">
        <ion-accordion-group mode="ios">
          <ion-accordion value="attachments" toggleIcon="none" toggleIconSlot="none">
            <ion-item class="text-sm" color="tertiary" slot="header">
              <ion-label class="gap-3 !grid">
                {{ student.attachments?.length }}
                {{ student.attachments?.length === 1 ? "Datei" : "Dateien" }}
              </ion-label>
              <ion-icon name="chevron-down-outline" slot="end"></ion-icon>
            </ion-item>
            <div slot="content">
              @for (attachment of student.attachments; track attachment) {
              <ion-item-sliding>
                <app-file-item
                  (fileClick)="openAttachment(attachment)"
                  (delete)="deleteAttachment(attachment)"
                  (share)="shareAttachment(attachment)"
                  (download)="openAttachment(attachment)"
                  [fileName]="attachment"
                  [canShare]="isSharePluginAvailable"
                ></app-file-item>
                <ion-item-options side="start">
                  <ion-item-option
                    color="danger"
                    (click)="deleteAttachment(attachment)"
                    expandable
                  >
                    Löschen
                  </ion-item-option>
                </ion-item-options>
              </ion-item-sliding>
              }
            </div>
          </ion-accordion>
        </ion-accordion-group>
      </ion-list>
      } } } @case ('lessons') { @defer (when !androidFakeLoading() && section
      === 'lessons') {
      <div class="mt-4">
        @if (upcomingAppointmentsSignal()?.length > 0 ||
        oldAppointmentsSignal()?.length > 0) { @if
        (upcomingAppointmentsSignal()?.length > 0) {
        <ion-item-divider mode="ios">
          <div class="flex w-full justify-between">
            <ion-label>Geplante Fahrstunden</ion-label>
            <div>
              {{ upcomingAppointmentsSignal()?.length }} ({{
                calculateTotalTime(upcomingAppointmentsSignal())
              }})
            </div>
          </div>
        </ion-item-divider>
        <ion-list color="dark" lines="none" class="mb-6 mt-4 rounded-lg">
          <ion-accordion-group mode="ios">
            <!-- order the appointments by start -->
            @for (appointment of upcomingAppointmentsSignal() | order: "asc";
            track JSON.stringify(appointment)) {
            <app-lesson-accordion
              [appointment]="appointment"
              [student]="student"
              (newInvoiceClick)="openNewInvoiceDialog(appointment)"
              (openInvoiceClick)="openInvoice($event)"
              (sendReminder)="sendReminder($event)"
            >
            </app-lesson-accordion>
            }
          </ion-accordion-group>
        </ion-list>
        } @if (oldAppointmentsSignal()?.length > 0) {
        <ion-item-divider mode="ios">
          <div class="flex w-full justify-between">
            <ion-label>Vergangene Fahrstunden</ion-label>
            <div>
              {{ oldAppointmentsSignal()?.length }} ({{
                calculateTotalTime(oldAppointmentsSignal())
              }})
            </div>
          </div>
        </ion-item-divider>
        <ion-list color="dark" lines="none" class="mb-6 mt-4 rounded-lg">
          <ion-accordion-group mode="ios">
            <!-- order the appointments by start -->
            @for (appointment of oldAppointmentsSignal() | order: "desc"; track
            JSON.stringify(appointment)) {
            <app-lesson-accordion
              [appointment]="appointment"
              [student]="student"
              (newInvoiceClick)="openNewInvoiceDialog(appointment)"
              (openInvoiceClick)="openInvoice($event)"
            >
            </app-lesson-accordion>
            }
          </ion-accordion-group>
        </ion-list>
        } } @else {
        <div class="ion-padding">
          <ion-label>
            Für {{ student.forename }} sind noch keine Termine geplant.
          </ion-label>
        </div>
        }
      </div>
      } } @case ('invoices') { @defer (when !androidFakeLoading() && section ===
      'invoices') {
      <div class="mt-4">
        <ion-item-divider mode="ios">
          <div class="flex w-full justify-between">
            <ion-label>Rechnungen</ion-label>
            <div>
              CHF
              {{ calculateTotalAmount(invoicesSignal()) | number : "1.2-2" }}
            </div>
          </div>
        </ion-item-divider>
        <ion-list color="dark" lines="none" class="mb-6 mt-4 rounded-lg">
          <ion-accordion-group mode="ios">
            <ion-accordion value="invoices" toggleIcon="none" toggleIconSlot="none">
              <ion-item class="text-sm" color="tertiary" slot="header">
                <ion-label class="gap-3 !grid">
                  <div class="!flex items-center gap-2">
                    <ion-badge color="primary">{{
                      getNumberOfOpenInvoices(invoicesSignal())
                    }}</ion-badge>
                    <ion-text class="text-xs" color="primary">Offen</ion-text>
                  </div>
                  <ion-text
                    >CHF
                    {{
                      getAmountOfOpenInvoices(invoicesSignal())
                        | number : "1.2-2"
                    }}</ion-text
                  >
                </ion-label>
                <ion-label class="gap-3 !grid">
                  <div class="!flex items-center gap-2">
                    <ion-badge color="success">{{
                      getNumberOfPaidInvoices(invoicesSignal())
                    }}</ion-badge>
                    <ion-text class="text-xs" color="success">Bezahlt</ion-text>
                  </div>
                  <ion-text
                    >CHF
                    {{
                      getAmountOfPaidInvoices(invoicesSignal())
                        | number : "1.2-2"
                    }}</ion-text
                  >
                </ion-label>
                <ion-label class="gap-3 !grid">
                  <div class="!flex items-center gap-2">
                    <ion-badge color="danger">{{
                      getNumberOfOverdueInvoices(invoicesSignal())
                    }}</ion-badge>
                    <ion-text class="text-xs" color="danger"
                      >Überfällig</ion-text
                    >
                  </div>
                  <ion-text
                    >CHF
                    {{
                      getAmountOfOverdueInvoices(invoicesSignal())
                        | number : "1.2-2"
                    }}</ion-text
                  >
                </ion-label>
                <ion-icon name="chevron-down-outline" slot="end"></ion-icon>
              </ion-item>
              <div slot="content">
                @for (invoice of invoicesSignal(); track invoice) {
                <ion-item
                  class="transparent"
                  detail="false"
                  button
                  (click)="openInvoice(invoice)"
                >
                  <app-invoice-item
                    class="w-full p-2"
                    [invoiceId]="invoice?.invoice_id"
                  ></app-invoice-item>
                </ion-item>
                }
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-list>
      </div>
      <div class="mt-4">
        <ion-item-divider mode="ios">
          <div class="flex w-full justify-between">
            <ion-label>Zahlungen</ion-label>
            <div>
              CHF {{ calculatePaidAmount(paymentsSignal()) | number : "1.2-2" }}
            </div>
          </div>
        </ion-item-divider>
        <ion-list color="dark" lines="none" class="mb-6 mt-4 rounded-lg">
          <ion-accordion-group mode="ios">
            <ion-accordion value="invoices">
              <ion-item class="text-sm" color="tertiary" slot="header">
                <ion-label class="gap-3 !grid">
                  {{ paymentsSignal()?.length }}
                  {{ paymentsSignal()?.length === 1 ? "Zahlung" : "Zahlungen" }}
                </ion-label>
              </ion-item>
              <div slot="content">
                @for (payment of paymentsSignal(); track payment) {
                <ion-item
                  class="transparent"
                  detail="false"
                  button
                  (click)="openPayment(payment)"
                >
                  <app-payment-item
                    class="w-full p-2"
                    [paymentId]="payment?.payment_id"
                  ></app-payment-item>
                </ion-item>
                }
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-list>
      </div>
      <div class="mt-4">
        <ion-item-divider mode="ios">
          <div class="flex w-full justify-between">
            <ion-label>Saldo</ion-label>
            <div>
              CHF
              {{
                calculatePaidAmount(paymentsSignal()) -
                  calculateTotalAmount(invoicesSignal()) | number : "1.2-2"
              }}
            </div>
          </div>
        </ion-item-divider>
      </div>
      } } @case ('education') { @defer (when !androidFakeLoading() && section
      === 'education') {
      <div class="mt-4">
        <div class="flex flex-row justify-between">
          <ion-button
            mode="ios"
            color="light"
            class="w-1/2"
            (click)="openEducationCard()"
          >
            Ausbildung
          </ion-button>
          <ion-button
            mode="ios"
            color="light"
            class="w-1/2"
            (click)="openExams()"
          >
            Prüfungen
          </ion-button>
        </div>
        <ion-item-divider mode="ios" class="mt-8">
          <div class="flex w-full justify-between">
            <ion-label>Fortschritt</ion-label>
            <div>{{ calculateOverallProgress() }}%</div>
          </div>
        </ion-item-divider>
        <ion-grid>
          <ion-row class="row">
            @for (educationTitle of educationCategorySignal()?.education_title;
            track educationTitle) {
            <ion-col class="col w-1/3" size="4">
              <ion-col>
                <ion-row
                  ><p class="education-title">
                    {{ educationTitle.title }}
                  </p></ion-row
                >
                <ion-row>
                  <circle-progress
                    class="max-w-52"
                    [percent]="getProgress(educationTitle)"
                    [responsive]="true"
                    [outerStrokeWidth]="10"
                    [innerStrokeWidth]="6"
                    [outerStrokeColor]="
                      getProgress(educationTitle) > 70
                        ? '#78C000'
                        : getProgress(educationTitle) > 30
                        ? '#FFD600'
                        : '#FF6F61'
                    "
                    [innerStrokeColor]="
                      getProgress(educationTitle) > 70
                        ? '#C7E596'
                        : getProgress(educationTitle) > 30
                        ? '#FFECB3'
                        : '#FFD6CC'
                    "
                    [animation]="false"
                    [subtitleColor]="
                      getProgress(educationTitle) > 70
                        ? '#67a700'
                        : getProgress(educationTitle) > 30
                        ? '#FFD600'
                        : '#FF6F61'
                    "
                    [titleColor]="
                      getProgress(educationTitle) > 70
                        ? '#78C000'
                        : getProgress(educationTitle) > 30
                        ? '#FFD600'
                        : '#FF6F61'
                    "
                    [unitsColor]="
                      getProgress(educationTitle) > 70
                        ? '#67a700'
                        : getProgress(educationTitle) > 30
                        ? '#FFD600'
                        : '#FF6F61'
                    "
                    [subtitle]="'Fortschritt'"
                    [renderOnClick]="false"
                  ></circle-progress>
                </ion-row>
              </ion-col>
            </ion-col>
            }
          </ion-row>
        </ion-grid>
      </div>
      } } }
    </div>
  </div>
  }} @if (androidFakeLoading()) {
  <ion-spinner
    class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
  ></ion-spinner>
  }
</ion-content>
